import {
  get_rem14pbkv8p42gid as get_rem,
  get_dp28ag147e4p5cz as get_dp,
  get_rem2p56fiaxda5jo as get_rem_0,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Companion_getInstancenv8qpb0wanrh as Companion_getInstance } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Paint.mjs';
import {
  Semanticpmpmvt7fldq2 as Semantic,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
  HoverSemantic_getInstance2nvjr5vpt4xe8 as HoverSemantic_getInstance,
  DownSemantic_getInstance12o2om5g6786l as DownSemantic_getInstance,
  SelectedSemantic_getInstance3ef29ujazc52t as SelectedSemantic_getInstance,
  UnselectedSemantic_getInstancexnnq5hq6ryv2 as UnselectedSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { isLetterOrDigit2kuxd9e198haf as isLetterOrDigit } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from './AppColors.mjs';
import {
  PerCorner27xb33zgvi5gv as PerCorner,
  Constant5dc3leeorpdb as Constant,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/CornerRadii.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function TabSemantics$default$lambda($this$to, it) {
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, get_rem(0.95), Edges().cd0(get_rem(0.95)));
}
function TabSemantics$default$lambda_0($this$to, it) {
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, it.qb0_1.db2().bb3() < 0.5 ? Companion_getInstance().taz_1 : Companion_getInstance().vaz_1, VOID, VOID, get_dp(0));
}
var TabSemanticsClass;
function TabSemantics() {
  if (TabSemanticsClass === VOID) {
    class $ extends Semantic() {
      static chg(color) {
        // Inline function 'kotlin.text.filter' call
        var tmp0 = color.raz();
        // Inline function 'kotlin.text.filterTo' call
        var destination = StringBuilder().d1();
        var inductionVariable = 0;
        var last = charSequenceLength(tmp0);
        if (inductionVariable < last)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var element = charSequenceGet(tmp0, index);
            if (isLetterOrDigit(element)) {
              destination.xb(element);
            }
          }
           while (inductionVariable < last);
        var tmp$ret$2 = destination.toString();
        var $this = this.dd1('tab' + tmp$ret$2);
        $this.bhg_1 = color;
        return $this;
      }
      ed1(theme) {
        var oldBackground = theme.qb0_1;
        var oldForeground = theme.lb0_1;
        var tmp0_gap = get_dp(4);
        var tmp1_padding = Edges().cd0(get_dp(4));
        var tmp2_background = this.bhg_1;
        var tmp3_foreground = Companion_getInstance().taz_1;
        var tmp = ButtonSemantic_getInstance();
        var tmp_0 = to(tmp, TabSemantics$default$lambda);
        var tmp_1 = HoverSemantic_getInstance();
        var tmp_2 = to(tmp_1, ($this$to, it) => {
          var back = it.qb0_1.db2();
          return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, back.equals(Companion_getInstance().taz_1) ? back : this.bhg_1.icz(0.6));
        });
        var tmp_3 = DownSemantic_getInstance();
        var tmp_4 = to(tmp_3, ($this$to, it) => {
          var back = it.qb0_1.db2();
          return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, back.equals(Companion_getInstance().taz_1) ? back : this.bhg_1.icz(0.8));
        });
        var tmp_5 = SelectedSemantic_getInstance();
        var tmp_6 = to(tmp_5, ($this$to, it) => {
          var tmp0_font = it.gb0_1.vd4(VOID, VOID, true);
          var tmp1_outlineWidth = get_dp(0);
          return $this$to.jd1(it, VOID, tmp0_font, VOID, VOID, VOID, VOID, oldForeground, VOID, VOID, tmp1_outlineWidth, VOID, oldBackground);
        });
        var tmp_7 = UnselectedSemantic_getInstance();
        var tmp4_derivations = mapOf([tmp_0, tmp_2, tmp_4, tmp_6, to(tmp_7, TabSemantics$default$lambda_0)]);
        return this.jd1(theme, VOID, VOID, VOID, VOID, tmp0_gap, tmp1_padding, tmp3_foreground, VOID, VOID, VOID, VOID, tmp2_background, VOID, VOID, VOID, VOID, VOID, tmp4_derivations);
      }
      toString() {
        return 'TabSemantics(color=' + this.bhg_1.toString() + ')';
      }
      hashCode() {
        return this.bhg_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TabSemantics()))
          return false;
        if (!this.bhg_1.equals(other.bhg_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'TabSemantics');
    TabSemanticsClass = $;
  }
  return TabSemanticsClass;
}
function get_workTabs(_this__u8e3s4) {
  return _this__u8e3s4.jbb(TabSemantics().chg(AppColors_getInstance().hfz_1.bga_1));
}
function OuterTabBar$default$lambda($this$to, it) {
  var tmp0_gap = get_rem(0.5);
  var tmp1_cornerRadii = new (PerCorner())(get_rem_0(1), true, true, false, false);
  return $this$to.jd1(it, VOID, VOID, VOID, tmp1_cornerRadii, tmp0_gap);
}
function OuterTabBar$default$lambda_0($this$to, it) {
  return it.ab1_1;
}
function OuterTabBar$default$lambda_1($this$to, it) {
  var tmp0_background = Companion_getInstance().taz_1;
  var tmp1_outline = AppColors_getInstance().ffz_1.zg9_1;
  var tmp2_outlineWidth = get_dp(2);
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp1_outline, tmp2_outlineWidth, VOID, tmp0_background);
}
function OuterTabBar$default$lambda_2($this$to, it) {
  return it.fb1(SelectedSemantic_getInstance());
}
var OuterTabBarClass;
function OuterTabBar() {
  if (OuterTabBarClass === VOID) {
    class $ extends Semantic() {
      static qjs() {
        OuterTabBar_instance = null;
        var $this = this.dd1('outtab');
        OuterTabBar_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_padding = Edges().cd0(get_rem(0.5));
        var tmp1_gap = get_rem(0.5);
        var tmp2_background = AppColors_getInstance().hfz_1.bga_1;
        var tmp3_foreground = AppColors_getInstance().efz_1.zg9_1;
        var tmp = ButtonSemantic_getInstance();
        var tmp_0 = to(tmp, OuterTabBar$default$lambda);
        var tmp_1 = UnselectedSemantic_getInstance();
        var tmp_2 = to(tmp_1, OuterTabBar$default$lambda_0);
        var tmp_3 = SelectedSemantic_getInstance();
        var tmp_4 = to(tmp_3, OuterTabBar$default$lambda_1);
        var tmp_5 = DownSemantic_getInstance();
        var tmp4_derivations = mapOf([tmp_0, tmp_2, tmp_4, to(tmp_5, OuterTabBar$default$lambda_2)]);
        return this.gd1(theme, VOID, VOID, VOID, VOID, tmp1_gap, tmp0_padding, tmp3_foreground, VOID, VOID, VOID, VOID, tmp2_background, VOID, VOID, VOID, VOID, VOID, tmp4_derivations);
      }
      toString() {
        return 'OuterTabBar';
      }
      hashCode() {
        return -1455150809;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OuterTabBar()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'OuterTabBar');
    OuterTabBarClass = $;
  }
  return OuterTabBarClass;
}
var OuterTabBar_instance;
function OuterTabBar_getInstance() {
  if (OuterTabBar_instance === VOID)
    OuterTabBar().qjs();
  return OuterTabBar_instance;
}
function InnerTabBar$default$lambda($this$to, it) {
  return $this$to.jd1(it, VOID, VOID, VOID, VOID, get_rem(0.5), Edges().cd0(get_rem(0.5)));
}
function InnerTabBar$default$lambda_0($this$to, it) {
  return $this$to.jd1(it);
}
function InnerTabBar$default$lambda_1($this$to, it) {
  var tmp0_background = Companion_getInstance().taz_1;
  var tmp1_outline = AppColors_getInstance().efz_1.zg9_1;
  var tmp2_outlineWidth = get_px(1);
  var tmp3_cornerRadii = new (Constant())(get_dp(1));
  var tmp4_foreground = equals(it.lb0_1, AppColors_getInstance().efz_1.zg9_1) ? AppColors_getInstance().ffz_1.zg9_1 : it.lb0_1;
  return $this$to.jd1(it, VOID, VOID, VOID, tmp3_cornerRadii, VOID, VOID, tmp4_foreground, VOID, tmp1_outline, tmp2_outlineWidth, VOID, tmp0_background);
}
var InnerTabBarClass;
function InnerTabBar() {
  if (InnerTabBarClass === VOID) {
    class $ extends Semantic() {
      static sjs() {
        InnerTabBar_instance = null;
        var $this = this.dd1('intab');
        InnerTabBar_instance = $this;
        return $this;
      }
      ed1(theme) {
        var tmp0_background = AppColors_getInstance().hfz_1.bga_1;
        var tmp1_foreground = AppColors_getInstance().efz_1.zg9_1;
        var tmp2_gap = get_dp(4);
        var tmp3_padding = Edges().cd0(get_dp(4));
        var tmp = ButtonSemantic_getInstance();
        var tmp_0 = to(tmp, InnerTabBar$default$lambda);
        var tmp_1 = UnselectedSemantic_getInstance();
        var tmp_2 = to(tmp_1, InnerTabBar$default$lambda_0);
        var tmp_3 = SelectedSemantic_getInstance();
        var tmp4_derivations = mapOf([tmp_0, tmp_2, to(tmp_3, InnerTabBar$default$lambda_1)]);
        return this.jd1(theme, VOID, VOID, VOID, VOID, tmp2_gap, tmp3_padding, tmp1_foreground, VOID, VOID, VOID, VOID, tmp0_background, VOID, VOID, VOID, VOID, VOID, tmp4_derivations);
      }
      toString() {
        return 'InnerTabBar';
      }
      hashCode() {
        return 72042178;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof InnerTabBar()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'InnerTabBar');
    InnerTabBarClass = $;
  }
  return InnerTabBarClass;
}
var InnerTabBar_instance;
function InnerTabBar_getInstance() {
  if (InnerTabBar_instance === VOID)
    InnerTabBar().sjs();
  return InnerTabBar_instance;
}
//region block: exports
export {
  TabSemantics as TabSemantics3r0nvsoryso8y,
  get_workTabs as get_workTabs3vd1ygveqjxgy,
  InnerTabBar_getInstance as InnerTabBar_getInstance20l55y0u7bopn,
  OuterTabBar_getInstance as OuterTabBar_getInstance2g83ti7eoew9h,
};
//endregion

//# sourceMappingURL=tabs.mjs.map
